import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';
import actionsFactory from 'utils/factories/actions';
import { AUTOMATION_CONDITION } from './actionTypes';

// actions
const actions = actionsFactory(AUTOMATION_CONDITION);
export { actions };

// reducer
const initialState = initialStateFactory([]);
const reducer = reducerFactory(AUTOMATION_CONDITION);
export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(AUTOMATION_CONDITION, '/automation_conditions');
export { sagas };
